import { render } from "./MemberCards.vue?vue&type=template&id=801db358&scoped=true"
import script from "./MemberCards.vue?vue&type=script&lang=js"
export * from "./MemberCards.vue?vue&type=script&lang=js"

import "./MemberCards.vue?vue&type=style&index=0&id=801db358&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-801db358"]])

export default __exports__